import { render } from "./LookupSelect.vue?vue&type=template&id=447ed460"
import script from "./LookupSelect.vue?vue&type=script&lang=js"
export * from "./LookupSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__